import * as api from '../api';
import * as types from '../constants/actions';
import { makeAsyncAction } from '../../../ui-lottery/src/utils/async_utils';

export const fetchFacilities = makeAsyncAction(
  types.FETCH_FACILITIES,
  () => () => api.getFacilities(),
  'facilities'
);
